import React from 'react'
import { Link } from 'react-router-dom'
import { ADMIN_AGENTS_SETTINGS_PATH } from '../../lib/dashboardNav'
import { useAgentPipelineReadiness } from '../../lib/useAgentPipelineReadiness'
import AgentPipelineGrid from './AgentPipelineGrid'
import './agentsPage.css'

export default function AgentsPage() {
  const readiness = useAgentPipelineReadiness(true)

  return (
    <div className="agents-page">
      <header className="agents-page-header">
        <h1 className="agents-page-title">Agents</h1>
        <p className="agents-page-lead">
          Run AI pipeline stages on live data. Agents are grouped by category; each square card is one agent you can run or open.
        </p>
        {!readiness.loading && readiness.summaryLine ? (
          <p className="agents-page-summary">{readiness.summaryLine}</p>
        ) : null}
      </header>

      <div className="agents-config-banner">
        To edit prompts, models, data sources, or digest automation, open{' '}
        <strong>Agents Setting</strong> in the Admin panel (
        <Link to={ADMIN_AGENTS_SETTINGS_PATH}>configure agents</Link>
        ).
      </div>

      <AgentPipelineGrid
        variant="workspace"
        badgesByAgentKey={readiness.badgesByAgentKey}
        statusHintByAgentKey={readiness.statusHintByAgentKey}
      />

      <footer className="agents-page-footer">
        <Link to="/admin/ai/agents-logs">Agents Logs</Link>
        <Link to={ADMIN_AGENTS_SETTINGS_PATH}>Agents Setting</Link>
        <Link to={`${ADMIN_AGENTS_SETTINGS_PATH}?tab=automation`}>Automation Settings</Link>
      </footer>
    </div>
  )
}
